import { render, staticRenderFns } from "./SiteDetailDashboard.vue?vue&type=template&id=4af5eb97&scoped=true"
import script from "./SiteDetailDashboard.vue?vue&type=script&lang=js"
export * from "./SiteDetailDashboard.vue?vue&type=script&lang=js"
import style0 from "./SiteDetailDashboard.vue?vue&type=style&index=0&id=4af5eb97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af5eb97",
  null
  
)

export default component.exports